import React from "react";
import { US_STATES, CA_PROVINCE_LIST, CA_PROVINCE_CODES } from "../utils/addressUtils";

export const StateProvinceSelect = ({ value, onChange, className = "", placeholder = "State", ...rest }) => {
  const known = US_STATES.includes(value) || CA_PROVINCE_CODES.includes(value);
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full h-9 rounded-md border border-input bg-transparent px-2 text-sm text-foreground appearance-none ${className}`}
      {...rest}
    >
      <option value="">{placeholder}</option>
      {value && !known && <option value={value}>{value}</option>}
      <optgroup label="US States">
        {US_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
      </optgroup>
      <optgroup label="Canadian Provinces">
        {CA_PROVINCE_LIST.map((p) => <option key={p.code} value={p.code}>{p.code} — {p.name}</option>)}
      </optgroup>
    </select>
  );
};

export default StateProvinceSelect;
